import { useEffect, useRef, useState,} from "react";
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import "bootstrap/dist/css/bootstrap.min.css";
import {HeroSection} from './Portfolio'

import HomeBannerVideo from "../components/Home/HomeBannerVideo";
import WhatisOrgavitaz from "../components/Home/WhatisOrgavitaz";
import WhyOrgavitaz from "../components/Home/WhyOrgavitaz";
import Features from "../components/Home/Features";
import ComplianceIcons from "../components/Home/ComplianceIcons";
import NewsAndTrendsSection from "../components/Home/NewsAndTrends";



   const gridImages = [
    {
      src: "/images/Home/DeficienciesOverview/25.png",
      title: "Product Identity",
      points: [
        "Bio-vitamers 'as-it-exists' in food",
        "Vitamer microenvironment synergy",
        "DNA Fingerprinted Botanical Identity",
        "Third Party Monitored Identity Program (VCS-MPP)",
        "Proprietary Agriculture Technology",
        "Green Chemistry",
      ],
    },
    {
      src: "/images/Home/DeficienciesOverview/26.png",
      title: "Sustainability",
      points: [  
      "CEORA - Sustainability innovation",
      "Sustainability as value-offer",
      "ICS – Livelihood Mission",
      "GAP and OCP – FarmFIT",
      "Sustainability Differential Pricing",
      "Climate Smart Interventions",
      "GRASP/SPRING/IFA",
      "ARISE – Rural Development Mission",
      ],
    },
    {
      src: "/images/Home/DeficienciesOverview/45.png",
      title: "Traceability",
      points: [
        "Organic Stewardship (Seed-Agriculture-Processing)",
        "Food Safety (FSSC 22000/GMP)",
        "Non-GMO Validation",
        "Third-Party Tested COA Validation",
        "Quality-By-Design Traceability",
        "Equivalences to EU/USDA and other nations",
        "Informed Shipment decision",
        
      ],
    },
    {
      src: "/images/Home/DeficienciesOverview/46.png",
      title: "Bio-Availability",
      points: [
        "Realtime Stability Studies",
        "Bioavailability Differential",
        "Active Cellular Nutrition",
        "Clinical Studies (Ongoing)",
        "Functional/Formulatory Studies",
        "Comprehensive Safety Assessment",
        "Bio-enhancement and Synergy",
      ],
    },
  ];

  const trendingProducts = [
  {
    image: "/images/Home/Trends/Ashwagandha.png",
    name: "Ashwagandha withanolides",
    tagline: "Ashwagandha withanolides bio-enhanced with Piperine and D3 for longevity. New ingredient that helps regenesis, DNA repair and healthy aging through telomerase activity and transcriptional regulation for stress response.",
  },
  {
    image: "/images/Home/Trends/Metabolein.png",
    name: "Metabolein-GLP-1",
    tagline: "Metabolein is our new ingredient that helps enhancing GLP-1 activity. Fenugreek and Garlic are naturally enhanced with Orgavitaz B1 and B6 for insulin sensitivity and Fat metabolism.",
  },
  {
    image: "/images/Home/Trends/Omega-D3.png",
    name: "Algal Omega-D3",
    tagline: "Say no to two supplements - single ingredient with synergistic benefits from our algal culture. Orgavitaz Omega-D3 is an effective approach to support heart health, immune function, and may help with pain and inflammation",
  },
  {
    image: "/images/Home/Trends/B-12Corrinoids.png",
    name: "B12-Corrinoids ",
    tagline: "Natural B12 active corrinoids of Shiitake seems to unburden some of the genetic defects of B12 absorption and metabolism. Originally, it supports nerve health and B12 deficiency.",
  },
  {
    image: "/images/Home/Trends/Agliberte.png",
    name: "Ag-Liberte",
    tagline: "Ag-Liberte is our sustainability initiative that brings all the SDG stakeholders together as annual event It networks, farmers, research scientists, supply chain partners and manufacturers for a common goal of sustainability. 6th Ag-liberte 2026 January 06, 2026 Coimbatore",
  },
];

const brandStyles = {
    primaryGreen: '#91C949',
    deepBlue: '#394C92',
    linkHover: '#68A637', // Slightly darker green for hover effect
    lightBg: '#F0F5EB', // A very light, green-tinted background
};


export default function Home() {


  //Portfolio
  const [homeHeroIndex, setHomeHeroIndex] = useState(0);
  const [homeAutoPlay, setHomeAutoPlay] = useState(true);


  return (
    <div className="bg-white">
    
       <HomeBannerVideo />

       <WhatisOrgavitaz />

       <Features />

       <WhyOrgavitaz />

       <HeroSection 
                currentIndex={homeHeroIndex} 
                setCurrentIndex={setHomeHeroIndex} 
                autoPlay={homeAutoPlay} // Set this to true or false as needed
            />
   
       <ComplianceIcons />

    <section className="py-5" style={{backgroundColor: brandStyles.deepBlue}}>
      <div className="container">
       <h2 className="fw-bold text-center mb-3" style={{ color: brandStyles.linkHover }}>
        USP - Product design
        </h2>
      {/* Inline style for hover effect using Bootstrap utilities only */}
      <style>{`
        .card-hover:hover .overlay {
            display: flex !important;
            opacity: 1 !important; /* Ensure opacity is fully visible on hover */
        }
      `}</style>
      <div className="row">
        {gridImages.map((img, index) => (
          <div className="col-md-6 mb-4" key={index}>
            <div className="card card-hover position-relative text-white overflow-hidden">
              <img
                src={img.src}
                className="card-img"
                alt={img.title}
                style={{ height: "300px", objectFit: "cover" }}
              />
              {/* Title centered */}
              <h3 className="position-absolute top-50 start-50 translate-middle text-center text-white fw-bold">
                {img.title}
              </h3>
              {/* Overlay with points */}
              <div
                className="overlay position-absolute top-0 start-0 w-100 h-100 bg-dark d-none flex-column justify-content-center align-items-center text-center p-3"
               style={{ backgroundColor: brandStyles.darkOverlay, opacity: 0 }}
              >
                {img.points.map((point, idx) => (
                  <p key={idx} className="mb-1">
                    • {point}
                  </p>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
      </div>
    </section>

   
    <NewsAndTrendsSection
    brandStyles={brandStyles} 
    trendingProducts={trendingProducts}
     />

    </div>
  );
}